import { render, staticRenderFns } from "./1BioData.vue?vue&type=template&id=3068f574&scoped=true"
import script from "./1BioData.vue?vue&type=script&lang=js"
export * from "./1BioData.vue?vue&type=script&lang=js"
import style0 from "./1BioData.vue?vue&type=style&index=0&id=3068f574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3068f574",
  null
  
)

export default component.exports